import { NumberId } from 'src/app/shared/state/number-id.model';

export interface Building extends NumberId {
  latitude: number;
  longitude: number;
  demand: number;
  vertex: number;
  vertex_latitude: number;
  vertex_longitude: number;
  properties: BuildingProperties;
}

export interface BuildingProperties {
  street_name?: string;
  number?: string;
  complement?: string;
  occupancy: 'Individual' | 'Collective';
  name?: string;
  type: 'Residential' | 'NonResidential' | 'Mixed';
  residential_units: number;
  nonresidential_units: number;
  orientation: 'Horizontal' | 'Vertical';
  blocks: BuildingBlock[];
}

export interface BuildingBlock {
  name: string;
  floors: number;
  residential_units: number;
  nonresidential_units: number;
}

export function createBuilding(params: Partial<Building>): Building {
  return {
    demand: 0,
    properties: {},
    ...params
  } as Building;
}

export function createBuildingProperties(params: Partial<BuildingProperties>): BuildingProperties {
  return {
    street_name: '',
    number: '',
    complement: '',
    occupancy: 'Individual',
    name: '',
    type: 'Residential',
    residential_units: 0,
    nonresidential_units: 0,
    orientation: 'Horizontal',
    blocks: [],
    ...params
  } as BuildingProperties;
}

export function createBuildingBlock(params: Partial<BuildingBlock>): BuildingBlock {
  return {
    name: '',
    floors: 1,
    residential_units: 0,
    nonresidential_units: 0,
    ...params
  } as BuildingBlock;
}
